// extracted by mini-css-extract-plugin
export default {"category":"category_category__sf83L","category_container":"category_category_container__u3-ak"};